// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import moment from 'moment'

export const exportValue = ({ columnKey, rowData }) => (
  moment(rowData[columnKey]).format('YYYY/MM/DD')
)

const FormatEpochToYYYYMMDD = props => {
  const date = exportValue(props)
  return (
    <div title={date}>
      {date}
    </div>
  )
}

FormatEpochToYYYYMMDD.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatEpochToYYYYMMDD
